import vendorRoutes from './vendorRoutes'
import allUserRoutes from './allUserRoutes'
import partnerRoutes from './partnerRoutes'
import AdMetrics from '@pages/reports/AdMetrics.vue'

const protectedRoute = (role) => {
  return {
    requiresAuth: true,
    requiredRole: role || undefined
  }
}

const routes = [
  {
    path: '/shared/salesforce',
    component: () => import('@layouts/HeaderlessLayout.vue'),
    children: [
      {
        name: 'shared-salesforce',
        path: '',
        component: AdMetrics,
        meta: { 
          title: 'Salesforce Metrics',
          requiresAuth: false,
          isSharedView: true
        }
      }
    ]
  },
  ...vendorRoutes,
  ...allUserRoutes,
  ...partnerRoutes,
  {
    name: 'partner-reg',
    path: '/org/:vendorSlug',
    component: () => import('@pages/partner-reg/PartnerRegistration.vue'),
    props: route => ({ slug: route.params.vendorSlug }),
  },
  {
    name: 'oauth-callback',
    path: '/spa/oauth-callback',
    component: () => import('@pages/OAuthCallback.vue'),
  },
  {
    name: 'oauth-callback',
    path: '/spa/oauth/hubspot',
    component: () => import('@pages/HubspotOAuthCallback.vue'),
  },
  {
    path: '/spa/admin',
    component: () => import('@layouts/ApplicationDataWrapper.vue'),
    meta: protectedRoute('admin'),
    children: [
      {
        name: 'media-optimizer',
        path: 'media-optimizer',
        component: () => import('@pages/admin-media-optimizer.vue'),
      },
      {
        name: 'campaign-metrics',
        path: 'campaigns/:campaignId/creative-rankings',
        component: () => import('@pages/admin-campaign-metrics.vue'),
      },
    ]
  },
  {
    // These routes are only used for local development right now.
    path: '/spa',
    component: () => import('@layouts/HeaderlessLayout.vue'),
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('@pages/login.vue'),
      },
      {
        name: 'auth0-callback',
        path: 'auth0-callback',
        component: () => import('@pages/auth0-callback.vue'),
      },
      {
        name: 'logout',
        path: 'logout',
        component: () => import('@pages/logout.vue'),
      },
      {
        name: 'terms',
        path: 'terms-acceptance-prompt',
        beforeEnter: () => {
          // check if they have accepted the terms already and route them to campaigns if so
        },
        component: () => import('@pages/TermsPrompt.vue'),
      },
    ]
  },
  {
    path: '/spa',
    redirect: { name: 'campaigns' }
  },
  {
    path: '/spa/:catchAll(.*)*',
    component: () => import('@pages/Error404.vue'),
  },
  {
    path: '/admin',
    component: () => import('@layouts/ApplicationDataWrapper.vue'),
    children: [
      {
        name: 'exit_impersonation_mode',
        path: 'exit_impersonation_mode',
        beforeEnter() {
          // This is a hack to get impersonation mode to exit on local.
          window.location.replace('https://localhost:8080/admin/exit_impersonation_mode')
        }
      }
    ]
  },
]

export default routes